import { UserRole } from '../server-types';
import { SOCIAL } from '../types';
var defaultConfig = {
    GOOGLE_AUTH_URL: 'https://accounts.google.com/o/oauth2/v2/auth?access_type=offline&response_type=code&client_id=686200956517-ekcd649hqj7nuf6q19grqp9ofqlvnqu4.apps.googleusercontent.com&scope=https://www.googleapis.com/auth/userinfo.email+https://www.googleapis.com/auth/userinfo.profile',
    LINKEDIN_AUTH_URL: 'https://www.linkedin.com/oauth/v2/authorization?scope=r_liteprofile,r_emailaddress&access_type=offline&response_type=code&client_id=86cpchio1khn04',
    FACEBOOK_AUTH_URL: 'https://www.facebook.com/v3.0/dialog/oauth?scope=public_profile,email,user_location&access_type=offline&response_type=code&client_id=168668320473884',
    AUTH_ENDPOINT: 'https://api.italianfood.net/api/authenticate',
    LOGIN_START_TRADITIONAL: false,
    HELP_EMAIL: 'support@gruppofood.com',
    OAUTH_REDIRECT_URI: 'https://auth.gruppofood.com/oauth2callback',
    DEFAULT_LOGGED_ROUTE: '/',
    AUTH_ROLES: [UserRole.Consumer],
    SOCIAL_TYPES: [SOCIAL.GOOGLE, SOCIAL.FACEBOOK, SOCIAL.LINKEDIN],
    LANG: 'it_IT',
    TARGET_SITE: 'IFN',
    VERIFICATION_URL: '/login',
};
var mergeConfig = function (c) {
    return Object.assign({}, defaultConfig, c);
};
export { mergeConfig };
//# sourceMappingURL=config.js.map